var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTicketDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M22.4532 26.375L37.2612 34.8086L22.8588 42.6262L8.05078 34.2343L22.4532 26.375Z",
    fill: "#D9D8D6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M28.1917 20.2705L42.9998 28.7041L34.3725 33.1448L19.5645 24.7527L28.1917 20.2705Z",
    fill: "#D9D8D6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.649 32.2039L17.8633 23.8693V10.1553L32.649 18.4898V32.2039Z",
    fill: "#FEF8E7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.649 18.4898L17.8633 10.1552V8.03589L32.649 16.3724V18.4898Z",
    fill: "#CB2110"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6494 32.204V18.4901L34.5299 17.4304V31.1465L32.6494 32.204Z",
    fill: "#D9D8D6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6494 18.4899V16.3726L34.5299 15.313V17.4303L32.6494 18.4899Z",
    fill: "#804419"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.649 16.3942L17.8633 8.05965L19.7418 7L34.5295 15.3365L32.649 16.3942Z",
    fill: "#804419"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7858 32.8991L8 24.5627V10.8486L22.7858 19.1832V32.8991Z",
    fill: "#FEF8E7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7858 19.1831L8 10.8485V8.72925L22.7858 17.0658V19.1831Z",
    fill: "#CB2110"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7852 32.8993V19.1834L24.6655 18.1257V31.8398L22.7852 32.8993Z",
    fill: "#D9D8D6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7852 19.1828V17.0655L24.6655 16.0059V18.1252L22.7852 19.1828Z",
    fill: "#804419"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7858 17.0873L8 8.75276L9.87836 7.69312L24.6661 16.0297L22.7858 17.0873Z",
    fill: "#804419"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M22.858 40.9745L8.07227 32.6399V18.9238L22.858 27.2604V40.9745Z",
    fill: "#FEF8E7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M22.858 27.2602L8.07227 18.9238V16.8064L22.858 25.141V27.2602Z",
    fill: "#CB2110"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8574 40.9743V27.2602L24.7358 26.2007V39.9146L22.8574 40.9743Z",
    fill: "#D9D8D6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8574 27.2599V25.1406L24.7358 24.083V26.2003L22.8574 27.2599Z",
    fill: "#804419"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M22.858 25.1644L8.07227 16.8299L9.95075 15.7703L24.7365 24.1049L22.858 25.1644Z",
    fill: "#804419"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1213 35.2068C19.8502 34.2321 19.8504 31.0721 18.1218 28.1486C16.3931 25.2252 13.5902 23.6453 11.8613 24.62C10.1324 25.5947 10.1321 28.7546 11.8608 31.6782C13.5894 34.6016 16.3923 36.1815 18.1213 35.2068Z",
    fill: "#CB2110"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1491 28.2644L13.1104 30.5411L14.1601 32.3165L18.1989 30.0397L17.1491 28.2644Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8338 27.7007L11.7832 28.2929L14.1627 32.317L15.2132 31.7248L12.8338 27.7007Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketDetails);
export default __webpack_public_path__ + "static/media/Ticket Details.c047822f71ff20c4fb18e9d107976687.svg";
export { ForwardRef as ReactComponent };